import 'regenerator-runtime';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './application-wide/App';
import fetchRuntimeConfig from './utils/fetchRuntimeConfig';
import './index.less';

const root = createRoot(window.document.getElementById('root'));
fetchRuntimeConfig().then(() => {
  root.render(<App basename={window?.baseAppConfig?.basePath} />);
});
